import { render, staticRenderFns } from "./feature-card.vue?vue&type=template&id=629430ac&scoped=true&"
import script from "./feature-card.vue?vue&type=script&lang=ts&"
export * from "./feature-card.vue?vue&type=script&lang=ts&"
import style0 from "./feature-card.vue?vue&type=style&index=0&id=629430ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629430ac",
  null
  
)

export default component.exports